import {useEffect} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';
import {SHOWED_GUEST_GROUP_MODAL} from 'utils/constants';
import {useSummary} from 'context/summary';
import {useModalOncePerSession} from '@chekin/shared';
import {useIsSessionModalReady} from 'hooks/useIsSessionModalReady';
import {useReservationSettingsModal} from 'components/ReservationSettingsModal';
import CheckInCompleteModal from 'components/CheckInCompleteModal';
import {LogoutModalSheet} from 'pages/Auth';
import {useModalControls} from '@chekinapp/ui';

function HomeViewModals() {
  const {reservationId} = useSummary();
  const isReady = useIsSessionModalReady();
  const {state} = useLocation();
  const navigate = useNavigate();

  const isLoggingOut = state?.isLoggingOut;

  const {shouldOpenModal: openWhoIsComingModalPerSession, markAsShown} =
    useModalOncePerSession({
      id: reservationId,
      storageKey: SHOWED_GUEST_GROUP_MODAL,
      isReady,
    });

  const {Modal: WhoIsComingModal} = useReservationSettingsModal({
    openModalPerSession: openWhoIsComingModalPerSession,
    showFirstTime: true,
    onAutoOpenDismiss: markAsShown,
  });

  const {
    isOpen: isLogoutModalOpen,
    openModal: openLogoutModal,
    closeModal: closeLogoutModal,
  } = useModalControls();

  useEffect(
    function handleOpenLogoutModal() {
      if (isLoggingOut) {
        openLogoutModal();
        navigate(location.pathname, {replace: true, state: {}});
      }
    },
    [openLogoutModal, isLoggingOut, navigate],
  );

  return (
    <>
      {WhoIsComingModal}
      <CheckInCompleteModal />
      <LogoutModalSheet open={isLogoutModalOpen} onClose={closeLogoutModal} />
    </>
  );
}

export {HomeViewModals};
